import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { Observable, Subscription } from "rxjs";
import { TemplatePortal } from "@angular/cdk/portal";
import { NgClass, NgIf } from "@angular/common";
import { environment } from "../../../environments/environment";
import { Environment } from "../../../environments/environment.model";

@Component({
  selector: "app-public-claim-modal",
  standalone: true,
  imports: [NgIf, NgClass],
  templateUrl: "./public-claim-modal.component.html",
  styleUrl: "./public-claim-modal.component.scss"
})
export class PublicClaimModalComponent implements OnInit, OnDestroy {
  @Input() marketplaceStatus: string | null = null;
  @Input() opportunityType: string | null = null;
  @Input() openModalObservable: Observable<void> = new Observable<void>();
  @ViewChild("template") template!: TemplateRef<any>;
  private overlayRef!: OverlayRef;
  private backdropClickSubscription!: Subscription;
  private openModalSubscription!: Subscription;
  protected readonly environment: Environment = environment;

  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit(): void {
    if (this.openModalObservable) {
      this.openModalSubscription = this.openModalObservable.subscribe((): void => this.openModal());
    }
  }

  ngOnDestroy(): void {
    if (this.backdropClickSubscription) {
      this.backdropClickSubscription.unsubscribe();
    }
    if (this.openModalSubscription) {
      this.openModalSubscription.unsubscribe();
    }
  }

  openModal(): void {
    if (this.overlayRef == null || !this.overlayRef.hasAttached()) {
      this.overlayRef = this.overlay.create({
        positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
        scrollStrategy: this.overlay.scrollStrategies.close(),
        hasBackdrop: true,
        backdropClass: "bg-slate-900/80"
      });
      const portal = new TemplatePortal(this.template, this.viewContainerRef);
      this.overlayRef.attach(portal);
      this.backdropClickSubscription = this.overlayRef.backdropClick().subscribe((): void => {
        this.closeModal();
      });
    }
  }

  closeModal(): void {
    if (this.overlayRef && this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
  }

  getSkinClass(): string {
    if (this.isMomentumEdge()) {
      return "momentumedge-theme";
    }

    if (this.isAgentium()) {
      return "agentium-theme";
    }

    return "";
  }

  isMomentumEdge(): boolean {
    const domain = this.getDomainWithoutTld();
    return domain === "trustedchoice" || domain === "momentumedge";
  }

  isAgentium(): boolean {
    return !this.isMomentumEdge();
  }

  getDomainWithoutTld(): string | null {
    let fullHostnameArray: string[] = window.location.hostname.split(".");

    if (fullHostnameArray == null || fullHostnameArray.length === 0) {
      return null;
    }

    if (fullHostnameArray.length === 1) {
      return fullHostnameArray[0];
    }

    return fullHostnameArray[fullHostnameArray.length - 2];
  }
}
